import ContactUs from "../../components/contact/contactUs";

const AffiliateDisclosure = () => {

    return (
        <div className="flex flex-col gap-12">


        <section className="home-container !bg-fraud-banner !h-[600px]  !bg-cover ">
            <div className="justify-center items-center flex flex-col gap-6 xs:!h-auto md:!h-auto xs:gap-16  xs:!pt-[120px] sm:!pt-[120px] md:!pt-[220px]  sm:!pb-[120px] xs:px-4 px-16 text-center sm:text-left">
            <h1 className="text-6xl text-white font-semibold">Affiliate Disclosure</h1>
            {/* <p className="text-white text-base">Whether you have a bunch of gift cards you want combine for a single purchase or a single card you just haven't gotten around to using</p> */}
            </div>

            </section>

            <div className=" px-16 pb-8 xs:px-4 space-y-4 ">
                <h5 className="text-black text-xl">
                In adherence to regulations set forth by the FEDERAL TRADE COMMISSION and the DEPARTMENT OF TREASURY, particularly the FINANCIAL CRIMES ENFORCEMENT NETWORK BUREAU, we hereby confirm the following:
                </h5>   

                   <h5 className="text-black text-xl">
                    <ul className=" pl-6">
                        <li className="li">
                        We are not affiliated with MasterCard, Visa, American Express, and/or any Gift Card Providers.

                        </li>
                        <li className="li">We are not in partnership with MasterCard, Visa, American Express, and/or any Gift Card providers.</li>
                        <li className="li">We do not utilize the trademarks, copyrights, and/or any intellectual property belonging to MasterCard, Visa, American Express, and/or any Gift Card providers to imply, suggest, or establish any form of partnership or affiliation.
</li>
                    
                    </ul>

                </h5> 

                 <h5 className="text-black text-xl">
                 If you believe that we have inaccurately disclosed the above information, we encourage you to submit a complaint and/or notice to our internal compliance department through the following channel:
                </h5>    

                <h5 className="text-black text-xl">
                E-MAIL INTERNAL COMPLIANCE DEPARTMENT
                <ul className=" pl-6">
                        <li className="li">
                        Email: support@lbdigital.info 
                            </li>
                            </ul>
                    </h5>  

                     <h5 className="text-black text-xl">
                     Your cooperation and feedback are vital to ensuring our commitment to transparency and compliance.                </h5>  
                     <h5 className="text-black text-xl">
                     Vizion Compliance Team

                        </h5>

                
            </div>
            <ContactUs />
        </div>
        
         
    )
}
export default AffiliateDisclosure;